import { render, staticRenderFns } from "./AppHeader.html?vue&type=template&id=452f6df2&scoped=true&external"
import script from "./AppHeader.ts?vue&type=script&lang=ts&external"
export * from "./AppHeader.ts?vue&type=script&lang=ts&external"
import style0 from "./AppHeader.scss?vue&type=style&index=0&id=452f6df2&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452f6df2",
  null
  
)

export default component.exports